/**
 * The short forms of a name. The initials a name draws where there is no picture: the first letter of its first and last
 * words. A module of its own, beside `Avatar.tsx` and without its Radix primitive, so the sign-in
 * card's mark draws the product's initial without bringing the Avatar, and with it the Radix
 * chunk, into the public entry (FR-015-120, 2026-09-28).
 */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter((p) => p.length > 0);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

/**
 * The first name a name shows where there is room for one word, the rail's account tile under the
 * avatar (2026-09-29): the name's first word, split on any run of white space as `initialsOf`
 * splits it, so "Ada Lovelace" shows "Ada", a one-word name shows whole and a name with no words
 * gives the empty string, for the caller to replace. A person's name has no given-name field
 * (001 `users.display_name` is one text of 1 to 80 characters), so the first word is the given name
 * in names written given name first, and is the family name where the person wrote it first.
 */
export function firstNameOf(name: string): string {
  return name.trim().split(/\s+/)[0] ?? "";
}
